import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "procesos",
    "proceso",
    "ProcesoForm",
    "/procesos",
);

export default handleActions(reducers, initialState);
